import { Sku } from '../screens/enrollment/Enrollment';
import { Order } from '../screens/user/Users';

export enum CouponTemplateRuleKey {
  SKUS_LIMITED,
  PAID_USER_ONLY,
}

export enum CouponType {
  DISCOUNT, // 折扣
  DEDUCTION, // 抵扣
}

export interface Coupon {
  id: number;
  couponTemplate: CouponTemplate;
  couponTemplateId: number;
  orders: Order[];
  source: number;
  sourceId: number;
  status: number;
  userId: number;
  validFrom: Date;
  validTo: Date;
  createdAt: Date;
}

export interface CouponRule {
  couponTemplate: CouponTemplate;
  couponTemplateId: number;
  remark: string;
  ruleKey: CouponTemplateRuleKey;
  // eslint-disable-next-line @typescript-eslint/ban-types
  ruleValue: Object;
}

export interface GCouponRule extends CouponRule {
  skus?: Sku[];
}

export interface CouponTemplate {
  id: number;
  amount: string;
  name: string;
  type: number;
  status: CouponTemplateStatus;
}

export enum CouponStatus {
  UNUSED,
  USED,
}

export enum CouponTemplateStatus {
  ACTIVE,
  INACTIVE,
}

export const CouponStatusText = {
  [CouponStatus.UNUSED]: '未使用',
  [CouponStatus.USED]: '已使用',
};

export const CouponTemplateStatusText = {
  [CouponTemplateStatus.ACTIVE]: '可用',
  [CouponTemplateStatus.INACTIVE]: '已停用',
};



// WEBPACK FOOTER //
// ./src/types/coupon.ts